var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 10.0343L14.5116 12.012L15.1853 14.9698C15.2224 15.1303 15.2129 15.2987 15.1578 15.4536C15.1027 15.6086 15.0045 15.7431 14.8757 15.8402C14.7469 15.9373 14.5932 15.9927 14.434 15.9993C14.2749 16.0059 14.1174 15.9635 13.9815 15.8774L11.5001 14.2944L9.01727 15.8774C8.88138 15.963 8.72408 16.0051 8.56519 15.9982C8.4063 15.9913 8.25293 15.9359 8.12438 15.8388C7.99583 15.7418 7.89785 15.6075 7.84278 15.4528C7.78772 15.2982 7.77802 15.1301 7.81492 14.9698L8.49103 12.012L6.27992 10.0343C6.15968 9.92654 6.07273 9.78448 6.02991 9.62584C5.98709 9.46719 5.99031 9.29899 6.03916 9.14223C6.08802 8.98547 6.18034 8.84711 6.3046 8.74441C6.42886 8.64172 6.57956 8.57925 6.73787 8.56481L9.63687 8.32236L10.7552 5.51691C10.8157 5.36401 10.9188 5.23323 11.0512 5.14119C11.1836 5.04915 11.3394 5 11.4989 5C11.6583 5 11.8141 5.04915 11.9466 5.14119C12.079 5.23323 12.182 5.36401 12.2425 5.51691L13.3604 8.32236L16.2594 8.56481C16.418 8.57871 16.5691 8.64083 16.6939 8.74338C16.8186 8.84594 16.9113 8.98436 16.9605 9.14131C17.0096 9.29826 17.013 9.46675 16.9702 9.62569C16.9274 9.78462 16.8403 9.92692 16.7198 10.0348L16.7227 10.0343Z",
    fill: "#799DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorIcon);
export default __webpack_public_path__ + "static/media/editor-icon.35df20557f48e7363cfab1cc9426288b.svg";
export { ForwardRef as ReactComponent };